"use client";

/*
  Josh Storer
  App: Wedding App
  File: components/WeddingFooterBar.tsx
  Component: WeddingFooterBar
  Version: v1.00
*/

import Link from "next/link";
import { Great_Vibes, Cormorant_Garamond } from "next/font/google";

const greatVibes = Great_Vibes({
  subsets: ["latin"],
  weight: "400",
});

const cormorant = Cormorant_Garamond({
  subsets: ["latin"],
  weight: ["400", "500", "600", "700"],
});

export default function WeddingFooterBar() {
  return (
    <footer className="border-t border-[#decf9b] bg-[linear-gradient(180deg,#f8f5ee_0%,#f2ede2_100%)]">
      <div className={`mx-auto flex w-full max-w-7xl flex-col gap-5 px-4 py-5 text-center sm:px-6 lg:flex-row lg:items-center lg:justify-between lg:px-8 lg:text-left ${cormorant.className}`}>
        <div>
          <p className="text-[11px] uppercase tracking-[.22em] text-[#8c8c86]">
            Wedding App
          </p>
          <p className="mt-2 text-sm leading-7 text-[#686861]">
            App created by{" "}
            <span className="font-semibold text-[#1f3f6d]">Josh Storer</span>
          </p>
        </div>

        <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 lg:justify-end">
          <Link
            href="/after-party"
            className={`${greatVibes.className} wedding-gold-halo text-2xl text-[#1f4e79] transition hover:text-[#173d61]`}
          >
            After Party
          </Link>

          <Link
            href="/booth"
            className={`${greatVibes.className} wedding-gold-halo text-2xl text-[#1f4e79] transition hover:text-[#173d61]`}
          >
            Photobooth
          </Link>

          <Link
            href="/message-from-josh"
            className={`${greatVibes.className} wedding-gold-halo text-2xl text-[#1f4e79] transition hover:text-[#173d61]`}
          >
            A Message from Josh
          </Link>

          <Link
            href="/login"
            className={`${greatVibes.className} wedding-gold-halo text-2xl text-[#1f4e79] transition hover:text-[#173d61]`}
          >
            Dashboard Login
          </Link>
        </nav>
      </div>
    </footer>
  );
}
